import { db } from "@/firebase";
import Store from './../index';

const MetaStore = {
  state: {
    meta: null,
    status: null,
    paymentConditions: null
  },

  mutations: {
    SET_META(state, meta) {
      state.meta = meta;
    },
    SET_META_THEMING(state, theming) {
      state.meta.theming = theming;
    },
    SET_META_COMPANY(state, company) {
      state.meta.company = company;
    },
    SET_STATUS(state, status) {
      state.status = status;
    },
    SET_PAYMENT_CONDITIONS(state, paymentConditions) {
      state.paymentConditions = paymentConditions;
    }
  },

  getters: {
    company: state => state.meta.company,
    theming: state => state.meta.theming,
    status: state => state.status,
    paymentConditions: state => state.paymentConditions,
  },

  actions: {
    getMeta({ commit }, organisation) {
      return new Promise((resolve, reject) => {
        db.collection("organisations")
          .doc(organisation)
          .collection("meta")
          .get()
          .then(
            querySnapshot => {
              let obj = {};
              querySnapshot.forEach(function(doc) {
                obj[doc.id] = doc.data();
              });
              commit("SET_META", obj);
              resolve(obj);
            },
            error => {
              reject(error);
            }
          );
      });
    },
    updateCompany({ commit }, company) {
      return new Promise((resolve, reject) => {
        db.collection("organisations")
          .doc(Store.getters.currentUser.organisation)
          .collection("meta")
          .doc("company")
          .set(company)
          .then(function() {
            commit("SET_META_COMPANY", company);
          })
          .catch(function(error) {
            reject(error);
          });
      });
    },
    updateTheming({ commit }, theming) {
      return new Promise((resolve, reject) => {
        db.collection("organisations")
          .doc(Store.getters.currentUser.organisation)
          .collection("meta")
          .doc("theming")
          .set(theming)
          .then(function() {
            commit("SET_META_THEMING", theming);
          })
          .catch(function(error) {
            reject(error);
          });
      });
    },
    getStatus({ commit }) {
      return new Promise((resolve, reject) => {
        db.collection("meta")
          .doc("status")
          .get()
          .then(
            doc => {
              if(doc.exists) {
                commit("SET_STATUS", Object.values(doc.data()));
              } else {
                //  First time to run the application, the database does not yet have the meta data, create the meta data
                // TODO : Set the default value as a config
                db.collection("meta")
                  .doc("status")
                  .set({0: "new", 1: "unsend", 2: "pending", 3: "incompletely", 4: "payed"})

              }
            },
            error => {
              reject(error);
            }
          );
      });
    },
    getPaymentConditions({ commit }) {
      return new Promise((resolve, reject) => {
        db.collection("meta")
          .doc("paymentConditions")
          .get()
          .then(
            doc => {
              if(doc.exists) {
                commit("SET_PAYMENT_CONDITIONS", Object.values(doc.data()));
              } else {
                //  First time to run the application, the database does not yet have the meta data, create the meta data
                // TODO : Set the default value as a config
                db.collection("meta")
                  .doc("paymentConditions")
                  .set({0: "none", 1: "payed"})

              }
            },
            error => {
              reject(error);
            }
          );
      });
    }
  }
};

export default MetaStore;
